// extracted by mini-css-extract-plugin
module.exports = {"page":"more_page__2S7xs","imgDog":"more_imgDog__14gCe","center":"more_center__1MOFx","btns":"more_btns__2L4mx"};